import styled from "styled-components/native";
import { navy_blue, royal_blue } from "../../StyleHelpers";
import { Props } from "./model";
import { Button } from "react-native-paper";

export const StyledBtnPaper = styled(Button)<Props>`
	background-color: ${(props) => (props.isHovered ? navy_blue : royal_blue)};
	border-radius: 16px;
`;

export const StyledBottomInnerContainer = styled.View`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	flex-basis: 100%;
`;

export const StyledTextContainer = styled.Text<any>`
	height: 4.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.5625rem;
`;
